import { h, proxyCustomElement, HTMLElement, Host } from '@stencil/core/internal/client';
import { S as Skeleton } from './skeleton.js';
import { d as defineCustomElement$1 } from './iframe-input2.js';

const BankAccountFormSkeleton = (props) => {
    const { isReady } = props;
    if (isReady) {
        return null;
    }
    return (h("div", { class: "container-fluid p-0" },
        h("div", { class: "row mb-3" },
            h("div", { class: "col-12 align-content-end" },
                h(Skeleton, { height: "18px", width: "120px" }),
                h(Skeleton, { height: "36px" }))),
        h("div", { class: "row" },
            h("div", { class: "col-12 align-content-end" },
                h(Skeleton, { height: "18px", width: "110px" }),
                h(Skeleton, { height: "36px" })))));
};

const BankAccountForm = /*@__PURE__*/ proxyCustomElement(class BankAccountForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.isReady = false;
    }
    async validate() {
        const accountNumberIsValid = await this.accountNumberIframeElement.validate();
        const routingNumberIsValid = await this.routingNumberIframeElement.validate();
        return accountNumberIsValid && routingNumberIsValid;
    }
    async tokenize(clientId, paymentMethodMetadata, account) {
        return this.accountNumberIframeElement.tokenize(clientId, paymentMethodMetadata, account);
    }
    componentDidRender() {
        const elements = [
            this.accountNumberIframeElement,
            this.routingNumberIframeElement,
        ];
        Promise.all(elements.map((element) => {
            return new Promise((resolve) => {
                element.addEventListener('iframeLoaded', () => { resolve(); });
            });
        })).then(() => {
            this.isReady = true;
        });
    }
    render() {
        return (h(Host, { key: '3d21d5269871beaffeffaef8b9c5104da59c1783' }, h(BankAccountFormSkeleton, { key: 'eb14285f2f0994085423901139f717c3b644273b', isReady: this.isReady }), h("div", { key: '906895204049f1113d596bade78de29bd5def6c2', class: "container-fluid p-0", style: {
                opacity: this.isReady ? '1' : '0',
                height: this.isReady ? 'auto' : '0',
            } }, h("div", { key: 'c56aa2cdec0c8be615dee4388346e890b2610b82', class: "row mb-3" }, h("iframe-input", { key: '5dd97225f360e267abf0c772b28ba890edf284db', inputId: "accountNumber", ref: (el) => (this.accountNumberIframeElement = el), label: "Account Number", iframeOrigin: `${this.iframeOrigin}/v2/accountNumber` })), h("div", { key: '20504c4b3c984c907765b99051a9e44ad6b5a37a', class: "row" }, h("iframe-input", { key: 'a85f47d87b01e099ac54969ce482abcc1fcb5366', inputId: "routingNumber", ref: (el) => (this.routingNumberIframeElement = el), label: "Routing Number", iframeOrigin: `${this.iframeOrigin}/v2/routingNumber` })))));
    }
}, [0, "bank-account-form", {
        "iframeOrigin": [1, "iframe-origin"],
        "isReady": [32],
        "validate": [64],
        "tokenize": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bank-account-form", "iframe-input"];
    components.forEach(tagName => { switch (tagName) {
        case "bank-account-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BankAccountForm);
            }
            break;
        case "iframe-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BankAccountForm as B, defineCustomElement as d };
